// `usePageContext` allows us to access `pageContext` in any Vue component.
// See https://vite-plugin-ssr.com/pageContext-anywhere

import { inject, type App } from 'vue'
import { PageContext } from '@root/types'

export { usePageContext }
export { setPageContext }

const key = Symbol('PageContext')

function usePageContext<T, R>(): PageContext<T, R> {
  const pageContext = inject<PageContext<T, R>>(key)
  if (!pageContext) throw new Error('setPageContext() not called in parent')
  return pageContext
}

function setPageContext<T, R>(app: App, pageContext: PageContext<T, R>): void {
  app.provide<PageContext<T, R>>(key, pageContext)
}
